import React, { useEffect } from 'react'
import { Chip, List, ListItem, ListItemText, Stack, Typography } from '@mui/material'

const StatusRow = ({ code, message }) => (
  <ListItem sx={{ border: 1, borderColor: 'divider', borderRadius: 1, mb: 1 }}>
    <ListItemText
      primary={
        <Stack direction='row' spacing={1} alignItems='center'>
          <Chip size='small' color='error' label={`Fatal: ${code}`} />
          <Typography>{message || 'No message'}</Typography>
        </Stack>
      }
    />
  </ListItem>
)

export const ResponseSection = ({ record, cache, ensureLoaded }) => {
  const { status, abiTransId } = record

  useEffect(() => {
    if (status === 'Rejected') {
      ensureLoaded(abiTransId)
    }
  }, [status, abiTransId, ensureLoaded])

  if (status === 'Accepted') {
    return (
      <List disablePadding>
        <ListItem sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
          <ListItemText
            primary={
              <Stack direction='row' spacing={1} alignItems='center'>
                <Chip size='small' color='success' label='Accepted' />
                <Typography>{record.responseMessage || 'DATA ACCEPTED AS REQUESTED'}</Typography>
              </Stack>
            }
          />
        </ListItem>
      </List>
    )
  }

  if (status === 'Rejected') {
    const entry = cache?.[abiTransId]

    if (!entry || entry.loading) {
      return <Typography color='text.secondary'>Loading response details...</Typography>
    }

    if (entry.error) {
      return <Typography color='error'>Unable to retrieve response details. Please try again later.</Typography>
    }

    if (!entry.data || entry.data.length === 0) {
      return <Typography color='text.secondary' fontStyle='italic'>No response data</Typography>
    }

    return (
      <List disablePadding>
        {entry.data.map((item) => (
          <StatusRow key={item.id} code={item.code} message={item.message} />
        ))}
      </List>
    )
  }

  return <Typography color='text.secondary' fontStyle='italic'>Awaiting response</Typography>
}

export default ResponseSection
